import { render, staticRenderFns } from "./BotaoSolicitarAssinatura.vue?vue&type=template&id=da07ebd2"
import script from "./BotaoSolicitarAssinatura.vue?vue&type=script&lang=js"
export * from "./BotaoSolicitarAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports